export default __webpack_public_path__ + "static/media/radio-correct.5fe8ae0b.svg";